import { useMediaQuery, useTheme } from '@mui/material';

/**
 * Global mobile detection hook.
 * Uses MUI breakpoints so all pages share the same definition of "mobile".
 *
 * Usage:
 *   const { isMobile, isTablet, isDesktop } = useMobile();
 *
 * Breakpoints (MUI defaults):
 *   xs  0–599    → isMobile  (phones)
 *   sm  600–899  → isTablet  (small tablets / large phones in landscape)
 *   md  900+     → isDesktop (tablets in landscape, laptops, desktops)
 */
export default function useMobile() {
  const theme = useTheme();
  const isMobile  = useMediaQuery(theme.breakpoints.down('sm'));   // <600
  const isTablet  = useMediaQuery(theme.breakpoints.between('sm', 'md')); // 600-899
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));     // ≥900

  return { isMobile, isTablet, isDesktop };
}
